import React, { Component } from "react";
import ReactDOM from "react-dom";
import { Link } from "react-router-dom";
import BootstrapTable from "react-bootstrap-table-next";
// import "bootstrap/dist/css/bootstrap.min.css";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
// import "./styles.css";
import { Button } from "react-bootstrap";


const products = [
  { id: 1, FirstName:"John", LastName:"Doe", PhoneNo: "+91 1548 5454 252", Email:"johandoe32@gmail.com"},
  { id: 2, FirstName:"John", LastName:"Doe", PhoneNo: "+91 1548 5454 252", Email:"johandoe32@gmail.com"},
  { id: 3, FirstName:"John", LastName:"Doe", PhoneNo: "+91 1548 5454 252", Email:"johandoe32@gmail.com"},
  { id: 4, FirstName:"John", LastName:"Doe", PhoneNo: "+91 1548 5454 252", Email:"johandoe32@gmail.com"}
];

class UsersTable extends Component {
  constructor() {
    super();
    this.state = {
      // For displaying data
      columns: [
        {
          dataField: "id",
          text: "Serial Number",
          sort: true
        },
        {
          dataField: "FirstName",
          text: "First Name",
          sort: true
        },
        {
          dataField: "LastName",
          text: "Last Name",
          sort: true
        },
       
          
          {
            dataField: "Email",
            text: "Email",
            sort: true
          },
          {
            dataField: "PhoneNo",
            text: "Phone No"
          },
         
       
        {
          dataField: "Delivery Report",
          text:  "",
          formatter: this.linkFollow2,
          sort: true
        }
      ],
      isFollow: true
    };

    this.onFollowChanged.bind(this);
  }

  onFollowChanged() {
    this.setState({ isFollow: !this.state.isFollow });
    console.log(this.state.isFollow);
  }

  onFollowChanged2() {
    this.setState({ isFollow: !this.state.isFollow });
    console.log(this.state.isFollow);
  }

  linkFollow2 = (cell, row, rowIndex, formatExtraData) => {
    return (
        <>
        
        <Link to="/view-user">
      <Button className="trash-btn"
        onClick={() => {
          this.onFollowChanged2(row);
        }}
      >
        <i class="bi bi-eye-fill"></i>
      </Button>
      </Link>
      <Link to="/edit-user">
      <Button className="trash-btn"
        onClick={() => {
          this.onFollowChanged2(row);
        }}
      >
        <i class="bi bi-pencil-square"></i>
      </Button>
      </Link>
     
      <Button className="trash-btn"
        onClick={() => {
          this.onFollowChanged2(row);
        }}
      >
        <i className="bi bi-trash3-fill"></i>
      </Button>

     </>
    );
  };

  render() {
    return (
        <>
       <div className="pract-table user-remarks" style={{overflowX:"auto"}}>
        <BootstrapTable
        insertRow
        deleteRow={true}
        responsive={true}
          keyField="id"
          striped={true}
          className="text-center"
          data={products}
          columns={this.state.columns}
        />
        </div>
      
      </>
    );
  }
}


export default UsersTable;